import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteInstrument, getInstruments } from '../../store/actions/instrument/instrument.action';
import InstrumentsList from '../../components/Instruments/Instruments';
import PageLoader from '../../components/Common/PageLoader';

const InstrumentsContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const instruments = useSelector((state) => state.instrument.list);
  const isFetching = useSelector((state) => state.instrument.isFetching); // Fixed: was state.era.isFetching
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const instrumentCategory = categories.find((category) => category.link === 'instruments');
      if (instrumentCategory) {
        setMode(instrumentCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Instrument category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete instrument
  const handleDeleteInstrument = useCallback((instrument) => {
    dispatch(deleteInstrument(instrument));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getInstruments());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare instrument info object
  const instrumentInfo = {
    deleteInstrument: handleDeleteInstrument,
    instruments
  };

  return (
    <section>
      <InstrumentsList mode={mode} instrumentInfo={instrumentInfo} />
    </section>
  );
};

export default InstrumentsContainer;
